import classnames from 'clsx';
import React from 'react';

import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import type { DateTimeOptions } from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import type { EventStatusSize } from '../../types';

import styles from './EventStatusTime.scss';

export interface Props {
  startTime: string;
  size: EventStatusSize;
  timeFormat?: Extract<DateTimeOptions['format'], 'long' | 'short' | 'time'>;
}

const getDateTimeProps = (timeFormat: Props['timeFormat'] = 'time'): DateTimeOptions => {
  switch (timeFormat) {
    case 'time':
    case 'short':
      return {
        format: timeFormat
      };
    case 'long':
      return {
        format: 'long',
        weekday: 'long'
      };
  }
};

const EventStatusTime = ({ startTime, size, timeFormat }: Props) => (
  <div
    className={classnames(styles.time, {
      [styles.timeXs]: size === 'XSmall',
      [styles.timeSm]: size === 'Small'
    })}
  >
    <FormattedDateTime date={startTime} {...getDateTimeProps(timeFormat)} />
  </div>
);

export default EventStatusTime;
